import { combineReducers } from "redux"
import { language } from './languageReducers'

const languageReducers = combineReducers({
    language,
})

export default languageReducers